module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "q_avatar",
    on: {
      "mouseover": function($event) {
        _vm.showImageControl(true)
      },
      "mouseleave": function($event) {
        _vm.showImageControl(false)
      }
    }
  }, [_c('img', {
    ref: "companyImage",
    staticClass: "img img-responsive",
    attrs: {
      "src": _vm.formData.imageUrl == '' ? (_vm.formData.picture ? _vm.formData.picture : '/static/img/placeholder.png') : '/image/Company/' + _vm.formData.imageUrl + '?' + Date.now(),
      "border": "1"
    }
  }), _vm._v(" "), _c('div', {
    ref: "imageControl",
    staticClass: "q_form_image_controls"
  }, [_c('span', {
    staticClass: "icon ion-pencil pull-left q_select_file_button",
    attrs: {
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.$refs.filePicture.click()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon ion-ios-trash-o pull-right q_clear_file_button",
    attrs: {
      "title": "Clear"
    },
    on: {
      "click": function($event) {
        _vm.clearPicture()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "q_hidden_input_file "
  }, [_c('input', {
    ref: "filePicture",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.pictureChange
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputName",
      "placeholder": "Company Name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("General Info")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_PROJECT
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onClickTabProject()
      }
    }
  }, [_vm._v("Projects")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    },
    attrs: {
      "id": "tab_1"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email),
      expression: "formData.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputEmail",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputAddress1"
    }
  }, [_vm._v("Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.address1),
      expression: "formData.address1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputAddress1",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "address1", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCurrency"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.currencyId),
      expression: "formData.currencyId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "currencyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listCurrency), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                                  " + _vm._s(row.name) + "\n                                ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v("Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.address2),
      expression: "formData.address2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputAddress2",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "address2", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputReportHeader"
    }
  }, [_vm._v("Report Header")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.reportHeader),
      expression: "formData.reportHeader"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputReportHeader",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.reportHeader)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "reportHeader", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputReportFooter"
    }
  }, [_vm._v("Report Footer")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.reportFooter),
      expression: "formData.reportFooter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputReportFooter",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.reportFooter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "reportFooter", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputSAPCode"
    }
  }, [_vm._v("SAP Code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.sapCode),
      expression: "formData.sapCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputSAPCode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.sapCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "sapCode", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_PROJECT
    },
    attrs: {
      "id": "tab_2"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.listProject), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.name))])])
  }))])])])])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.id),
      expression: "formData.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "id": "inputId"
    },
    domProps: {
      "value": (_vm.formData.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.currencyId),
      expression: "formData.currencyId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "id": "inputProductTypeId"
    },
    domProps: {
      "value": (_vm.formData.currencyId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "currencyId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.onCancel()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onSave()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onEdit(_vm.formData)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onCreate()
      }
    }
  }, [_vm._v("Create")]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Name")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6254f14a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/CompanyForm.vue
// module id = 746
// module chunks = 1